import { AxiosResponse, AxiosError } from "axios"
import ConnectApi from "../../baseService"
import { TApiResponse } from "../../TApiResponse"
import {
  TZyomuinUnkoGeppoSummaryListGetReq,
  TZyomuinUnkoGeppoListGetReq,
  TZyomuinUnkoGeppoSummaryListGetRes,
  TZyomuinUnkoGeppoListGetRes,
  TZyomuinUnkoGeppoPrintReq,
  TZyomuinUnkogeppoCreateReq,
  TZyomuinUnkoGeppoTeatePutReq,
} from "./TZyomuinUnkoGeppo"

/**
 * 乗務員運行月報に対するAPIリクエスト用サービス
 *
 * @export
 * @class MenuService
 * @extends {ConnectApi}
 */
export default class ZyomuinUnkoGeppoService extends ConnectApi {
  /**
   * 検索取得
   *
   * @param {TZyomuinUnkoGeppoSummaryListGetReq} params
   * @param {(param: TApiResponse<TZyomuinUnkoGeppoSummaryListGetRes[]>) => any} resolve
   * @param {(param: TApiResponse<TZyomuinUnkoGeppoSummaryListGetRes[]>) => any} reject
   * @memberof MenuService
   */
  getSummaryList = async (params: TZyomuinUnkoGeppoSummaryListGetReq) => {
    try {
      const res: AxiosResponse<
        TApiResponse<TZyomuinUnkoGeppoSummaryListGetRes>
      > = await this.getInner(`/driverpayroll/zyomuinunkogepposummary`, params)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 乗務員運行月報 取得
   *
   * @param {TZyomuinUnkoGeppoListGetReq} params
   * @param {(param: TApiResponse<TZyomuinUnkoGeppoListGetRes、[]>) => any} resolve
   * @param {(param: TApiResponse<TZyomuinUnkoGeppoListGetRes、[]>) => any} reject
   * @memberof MenuService
   */
  getList = async (params: TZyomuinUnkoGeppoListGetReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TZyomuinUnkoGeppoListGetRes[]>> =
        await this.getInner(`/driverpayroll/zyomuinunkogeppo`, params)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 乗務員運行月報 帳票作成
   *
   * @param {TZyomuinUnkoGeppoPrintReq} params
   * @memberof zyomuinUnkoGeppoService
   */
  printZyomuinUnkoGeppo = async (
    params: TZyomuinUnkoGeppoPrintReq,
    resolve?: (param: TApiResponse<Blob>) => any,
    reject?: (param: AxiosError<TApiResponse<Blob>>) => any
  ) => {
    try {
      //API呼出
      const res: AxiosResponse<Blob> = await this.postInner(
        `/report/CreateReport/G110102`,
        params
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 乗務員運行月報 集計実行
   *
   * @param {TZyomuinUnkogeppoCreateReq} params
   * @memberof zyomuinUnkoGeppoService
   */
  calcZyomuinUnkoGeppo = async (
    params: TZyomuinUnkogeppoCreateReq,
    resolve?: (param: TApiResponse<boolean>) => any,
    reject?: (param: AxiosError<TApiResponse<boolean>>) => any
  ) => {
    try {
      //API呼出
      const res: AxiosResponse<boolean> = await this.postInner(
        `/driverpayroll/zyomuinunkogeppo/actions/create`,
        params
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 乗務員運行月報 手当更新
   *
   * @param {TZyomuinUnkoGeppoTeatePutReq} data
   * @param {(param: TApiResponse<TKyotenRes>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<TKyotenRes>>) => any} reject
   * @memberof zyomuinUnkoGeppoService
   */
  putTeate = async (id: string, data: TZyomuinUnkoGeppoTeatePutReq) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `/driverpayroll/zyomuinunkogeppo/actions/updateteate/${id}`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }
}
